export default __webpack_public_path__ + "media/zurb/img/blog/blogpost-hero-screenshot-15b43d4fe5d2223dde334c0a204e6481.png";